import { FormControl, Grid } from "@mui/material";
import { AutoCompleteDataModel } from "components/MprcAutoComplete";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { ButtonCancel } from "components/buttons";
import { ButtonApplyFilter } from "components/buttons/ButtonApplyFilter";
import { MprcInputStyles } from "components/filter/MprcInputStyles";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserBlockReasonAutoComplete } from "views/foundation/user/components/UserBlockReasonAutoComplete";
import { IAdvFilterPickerProps } from "views/general/AdvancedFilter/interfaces";

////////////////////////////////////////////////////////////////////////////

export const UserBlockReasonPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel } = props;
    const { t } = useTranslation();
    const multiSelect = filter.canRepeat ?? false;

    const [selected, setSelected] = useState<AutoCompleteDataModel[]>([]);
    const inputRef = useRef<HTMLInputElement>(undefined);

    ///
    const handleApply = () => {
        if (selected.length > 0) {
            const newFilter = selected.map(item => ({
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${item.label}`,
                value: item.key,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: null
            }));
            onApply(newFilter, filter);
        }
    };

    ///
    useEffect(() => {
        (inputRef as any)?.current?.focus();
    }, [inputRef]);

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2}>
            <Grid size="grow">
                <FormControl fullWidth>
                    <UserBlockReasonAutoComplete
                        autoFocus
                        multiSelect={multiSelect}
                        label={t("shared:AdvFilter.Picker.UserBlockReason.BlockReasonLabel")}
                        selectedItems={selected}
                        onChange={(items) => setSelected(items)}
                        onError={MprcRequestSnackbarErrorReport}
                        hasAllReason
                        onApply={handleApply}
                        onCancel={onCancel}
                        sx={MprcInputStyles.filter}
                        inputRef={inputRef}
                    />
                </FormControl>
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected.length == 0}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
